
import React, { useState } from 'react'
import {AppGridBar,AppForm,AppGridTabs, AppTable} from 'qcc'
import { Row, Col} from 'antd';
import api, {PosAppGetinIuput,HttpResult, PosAppGetinFeeIuput} from 'api';
import {PosApiInputBar} from '../components/PosApiInputBar'
import {PosApiInputContent} from '../components/PosApiInputContent'

let inputConfig = {
    example : {chinaPayRefId:"1234",payMode:"card",projectId:830810371568,scene:"zsk",refId:"123",customerId:1,posBankId:1,amount:125021.01,posCode:'1321354321',
    mac:"00-01-02-03-04-05",bankNumber:"687646876465761257",placeholder:"张三",extOrderNo:"1345341334",resCode:"sas57541",amt:"125021.01",merchantNo:"xasa5464",
    terminalNo:"6w74a61654sasa",merchantName:"开发王中王",batchNo:"15601541",traceMo:"wasdas4554",refNo:"s45as",cardIssuer:"农业银行",date:"2018-1-11",time:"2018-2-22",
    settleDate:"2019-8-7",payNo:"7758258"
    } as PosAppGetinIuput,
    formdata:{} as PosAppGetinIuput,
    labelWidth:100 ,
    items:
    [
        {lable:'PayRefId',field:'chinaPayRefId',placeholder:'string类型'},
        {lable:'支付方式',field:'payMode',placeholder:'string类型'},
        {lable:'项目ID',field:'projectId',placeholder:'string类型'},
        {lable:'收款场景',field:'scene',placeholder:'string类型'},
        {lable:'关联ID字段',field:'refId',placeholder:'string类型'},
        {lable:'客户ID',field:'customerId',placeholder:'number类型'},
        {lable:'收款金额',field:'amount',placeholder:'number类型'},
        {lable:'Pos小票code',field:'posCode',placeholder:'string类型'},
        {lable:'posMAc地址',field:'mac',placeholder:'string类型'},
        {lable:'收款卡号',field:'bankNumber',placeholder:'string类型'},
        {lable:'收款人姓名',field:'payer',placeholder:'string类型'},
        {lable:'银行流水号',field:'extOrderNo',placeholder:'string类型'},
        {lable:'入帐银行ID',field:'posBankId',placeholder:'number类型'},
        {lable:'返回码',field:'resCode',placeholder:'string类型'},
        {lable:'交易金额',field:'amt',placeholder:'string类型'},
        {lable:'商户号',field:'merchantNo',placeholder:'string类型'},
        {lable:'终端号',field:'terminalNo',placeholder:'string类型'},
        {lable:'商户名',field:'merchantName',placeholder:'string类型'},
        {lable:'批次号',field:'batchNo',placeholder:'string类型'},
        {lable:'凭证号',field:'traceMo',placeholder:'string类型'},
        {lable:'参考号',field:'refNo',placeholder:'string类型'},
        {lable:'发卡行名称',field:'cardIssuer',placeholder:'string类型'},
        {lable:'日期',field:'date',placeholder:'string类型'},
        {lable:'时间',field:'time',placeholder:'string类型'},
        {lable:'清算日期',field:'settleDate',placeholder:'string类型'},
        {lable:'付款码',field:'payNo',placeholder:'string类型'},
        
    ]
} as PosAppGetinIuput;

let outputExample = {
   
    msg:'',
    result:true,
    data:{
           
        } 
} as HttpResult

export interface Props{
    current?:string
}

export const AppGetFund = (props:Props) =>{

    const[outputResult,setOutputResult]  = useState(null as HttpResult)
    const[outputView,setOutputView]  = useState(0)

    const execApi = async () =>{
        let inputParam = refPosApiInputContent.current.getFormData();
        inputParam.getinFeeList=[{erpFeeId:'1',amount:1000},{erpFeeId:'2',amount:2000},{erpFeeId:'3',amount:3000}] as PosAppGetinFeeIuput[];
        let res = await api.posapp.getFund(inputParam);
        setOutputResult(res);
    }

    const renderOutput = () =>{
        if(outputResult===null) return '';
        switch(outputView){
            case 0:
            return renderOutputForm();
            case 1:
            return renderJson();
        }

        return '';
    }

    const renderOutputForm = () =>{
        return ( <AppForm  loadingData={false} formData={{...outputResult}}>
            <AppForm.Section labelWidth={150}>
                <AppForm.Item label='失败信息（msg）:' field='msg' itemType='input' readonly/>
                <AppForm.Item label='结果（result）:' field='result' itemType='input' readonly/>
            </AppForm.Section>
        </AppForm>)
    }

    const renderJson = () =>{
        return <pre>{JSON.stringify(outputResult, null, 4)}</pre>
    } 
    
    let refPosApiInputContent = React.createRef<PosApiInputContent>();
    return (<div className='app-demo-content'>
            <h1>PosApp获取交易</h1>    
            <div>
                1、Pos端获取客户交易<br/>
                2、地址：/api/posApp/getFee <br/>
            </div>

            <div className='app-pos-api-input'>
                <PosApiInputBar  fn={execApi}/>
                <div className='app-pos-api-input-line'/>
                <PosApiInputContent ref={refPosApiInputContent} config={inputConfig} />
            </div>

            <div className='app-pos-api-input'>
                <AppGridBar>
                    <AppGridBar.Left>
                        <AppGridTabs defaultTabIndex={outputView} 
                        onChange={(tabIndex)=>{setOutputView(tabIndex)}} 
                        tabs={['表单（HttpResult）','JSON']}/>
                    </AppGridBar.Left>
                </AppGridBar>
                <div className='app-pos-api-input-line'/>
                <Row className='app-pos-api-input-content'>
                    <Col span={16} className='app-pos-api-input-form'>
                        {renderOutput()}
                    </Col>
                    <Col span={8} className='app-pos-api-input-example'>
                        <div>示例：</div>
                        <pre>{JSON.stringify(outputExample, null, 4)}</pre>
                    </Col>
                </Row>

            </div>

            
            
    </div>)
}


// WEBPACK FOOTER //
// ./src/posapi/app/AppGetFund.tsx